import { searchTypes } from '../pages/kyb/constants'

export const buildKybParams = (query = {}) => {
  const {
    email,
    fromDate,
    toDate,
    searchType,
    searchText,
    status,
    riskLevel,
    creationOrigin,
    businessSegments,
    cluster,
    site,
    legalRepresentative,
    legalRepresentativeEmail,
    legalRepresentativePhone,
    legalRepresentativeDocumentNumber,
    clientTypes,
    products,
    dateOfBirth, 
    monitored,
    gender,
    phoneNumber,
    nationality
  } = query
  const params = {}

  if(dateOfBirth) {
    params.dateOfBirth = dateOfBirth
  }

  if(monitored !== undefined) {
    params.monitored = monitored
  }

  if(gender) {
    params.gender = gender
  }

  if(phoneNumber) {
    params.phoneNumber = phoneNumber
  }

  if(nationality) {
    params.nationality = nationality
  }

  if (email) {
    params.email = email
  }

  if (fromDate && toDate) {
    params.fromDate = fromDate
    params.toDate = toDate
  }

  if (searchTypes.includes(searchType) && !!searchText) {
    params[searchType] = searchText
  }

  if (status !== 'ALL' && !!status) {
    params.status = status
  }

  if (riskLevel) {
    params.riskLevel = riskLevel
  }

  if (creationOrigin) {
    params.creationOrigin = creationOrigin
  }

  if (businessSegments) {
    params.businessSegments = businessSegments
  }

  if (cluster) {
    params.cluster = cluster
  }

  if (site) {
    params.site = site
  }

  if (legalRepresentative) {
    params.legalRepresentative = legalRepresentative
  }

  if (legalRepresentativeEmail) {
    params.legalRepresentativeEmail = legalRepresentativeEmail
  }

  if (legalRepresentativePhone) {
    params.legalRepresentativePhone = legalRepresentativePhone
  }

  if (legalRepresentativeDocumentNumber) {
    params.legalRepresentativeDocumentNumber = legalRepresentativeDocumentNumber
  }

  if (clientTypes) {
    params.clientTypes = clientTypes
  }

  if (products) {
    params.products = products
  }

  if (query.businessSegments) {
    params.businessSegments = query.businessSegments
  }

  const brazilFields = [
    'fantasia',
    'registrationStatus',
    'capitalSocial',
    'legalOrganization',
    'size',
    'simplesNacional',
    'monthlyQty',
    'lawsuits',
    'tpv',
    'motherName',
    'rendaPresumida',
    'situacaoImpostoRenda',
    'cpfRegistrationDate',
    'presumedIncome'
  ];

  brazilFields.forEach((field) => {
    if (query[field]) {
      params[field] = query[field];
    }
  });
  
  return params
}

export const cleanParams = (params) => {
  const filteredParams = {}
  for (const key in params) {
    if (params[key] !== null && params[key] !== '' && params[key] !== undefined) {
      filteredParams[key] = params[key]
    }
  }
  return filteredParams
}
